/* eslint jsx-a11y/no-noninteractive-element-interactions: 0 */
/* eslint jsx-a11y/click-events-have-key-events: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';

import { TranslatedCopy } from '../../../intl/TranslatedCopy';

import { Date, Icon } from '../../../components/';

import { getCurrentAllotments, getFutureAllotments } from '../../../gamedayAccount/selectors';
import { getUserData } from '../../../user/selectors';

import { navRouteType } from '../../../types/nav';
import { userTypes } from '../../../types/user';

export class LargeScreenLink extends Component {
  handleClick = () => {
    if (this.linkWrap && this.linkWrap.children) {
      // NavLink doesn't accept the ref so we have to drill down to it
      this.linkWrap.children[0].blur();
    }
  };

  handleLinkClick = e => {
    const { route } = this.props;
    const { [route.disableWhenEmpty]: disableWhenEmpty } = this.props;
    if (route.disableWhenEmpty && Object.keys(disableWhenEmpty).length === 0) {
      e.preventDefault();
    }
  };

  render() {
    const { route, subRoutes, user } = this.props;
    const { [route.disableWhenEmpty]: disableValue, [route.titleSubCopy]: titleSubCopy } = this.props;
    const { limitToRoles } = route;
    const { disableLink = false } = route;
    return (
      (!limitToRoles || limitToRoles.indexOf(user.role) > -1) && (
        <li
          onClick={this.handleClick}
          ref={linkWrap => {
            this.linkWrap = linkWrap;
          }}
        >
          <NavLink
            to={route.path}
            className={classnames('body-3 u-bold mb1-sm text-color-secondary d-sm-b', {
              isDisabled: (disableValue && Object.keys(disableValue).length === 0) || disableLink
            })}
            exact
            onClick={this.handleLinkClick}
            data-desc={`navListLargeScreen_link__${route.title}`}
          >
            <TranslatedCopy id={route.title} />
            {titleSubCopy && titleSubCopy.contractStartDate && titleSubCopy.contractEndDate && (
              <span className='nav__title-subCopy body-4 pl2-md'>
                (
                <Date value={titleSubCopy.contractStartDate} timeZone='UTC' />
                {' - '}
                <Date value={titleSubCopy.contractEndDate} timeZone='UTC' />)
              </span>
            )}
            {subRoutes && <Icon name='chevron-down-cell' alt='close account menu' className='ml1-sm' />}
          </NavLink>
          {subRoutes}
        </li>
      )
    );
  }
}

LargeScreenLink.defaultProps = {
  subRoutes: null,
  user: null
};

LargeScreenLink.propTypes = {
  route: navRouteType.isRequired,
  subRoutes: PropTypes.element,
  user: userTypes
};

const mapStateToProps = state => ({
  currentAllotments: getCurrentAllotments(state),
  futureAllotments: getFutureAllotments(state, true),
  user: getUserData(state)
});

const connector = connect(mapStateToProps, {});

export default connector(LargeScreenLink);
